import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export function ImpersonateButton({ path }: { path: string }) {
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      onClick={() => router.post(path)}
    >
      Impersonate
    </Button>
  )
}
